import React from 'react';
import {Flex} from "antd";
import {clrs} from "../../../constants/colors";
import MyText from "../../../components/UI/Text/MyText";
import IntlMessage from "../../../components/IntlMessage/IntlMessage";
import classes from './projectGoals.module.css';

const ProjectGoals = () => {
    const goals = [
        {
            id: 1,
            headKey: 'homePage.goalsProject.1.head',
            bodyKey: 'homePage.goalsProject.1.body',
            bgColor: clrs.whiter3AquaGeo
        },
        {
            id: 2,
            headKey: 'homePage.goalsProject.2.head',
            bodyKey: 'homePage.goalsProject.2.body',
            bgColor: clrs.blue
        },
        {
            id: 3,
            headKey: 'homePage.goalsProject.3.head',
            bodyKey: 'homePage.goalsProject.3.body',
            bgColor: clrs.whiter3AquaGeo
        },
        {
            id: 4,
            headKey: 'homePage.goalsProject.4.head',
            bodyKey: 'homePage.goalsProject.4.body',
            bgColor: clrs.blue
        }
    ];

    return (
        <Flex
            style={{
                width: "100%",
                position: "relative",
                background: clrs.blue
            }}
            align={"center"}
            justify={"center"}
            vertical
        >
            <div style={{
                height: 80,
                borderTopLeftRadius: "100px",
                borderTopRightRadius: "100px",
                backgroundColor: "white",
                width: "100%",
            }}></div>
            <Flex
                style={{
                    width: "100%",
                    position: "relative",
                    padding: "0px 20px 60px 20px",
                    // marginTop: "-100px",
                    background: "white",
                    // borderTopLeftRadius: "40px",
                    // borderTopRightRadius: "40px"
                }}
                align={"center"}
                justify={"center"}
            >
                <Flex
                    gap={50}
                    style={{width: "100%", maxWidth: 1440, position: "relative"}}
                    vertical
                    align={"center"}
                    justify={"flex-start"}
                >
                    <MyText
                        style={{
                            fontSize: "2.5rem",
                            fontWeight: 900,
                            color: clrs.textColor,
                            textAlign: "center",
                            marginBottom: "40px"
                        }}
                    >
                        <IntlMessage id={'homePage.goalsProject'}/>
                    </MyText>

                    <Flex
                        style={{width: "100%"}}
                        wrap
                        gap={30}
                        justify={"center"}
                    >
                        {goals.map((goal) => (
                            <Flex
                                key={goal.id}
                                className={classes.goalCard}
                                style={{
                                    backgroundColor: goal.bgColor,
                                    borderRadius: "20px",
                                    padding: "40px 30px",
                                    width: "300px",
                                    // maxWidth: "480px",
                                    height: "350px",
                                    textAlign: "center",
                                }}
                                vertical
                                align={"center"}
                                justify={"center"}
                                gap={20}
                            >
                                <MyText
                                    style={{
                                        fontSize: "1.5rem",
                                        fontWeight: 800,
                                        color: goal.bgColor === clrs.blue ? "white" : clrs.textColor,
                                        lineHeight: "1.3"
                                    }}
                                >
                                    <IntlMessage id={goal.headKey}/>
                                </MyText>

                                <MyText
                                    style={{
                                        fontSize: "1rem",
                                        fontWeight: 400,
                                        color: goal.bgColor === clrs.blue ? "white" : clrs.textColor,
                                        lineHeight: "1.5",
                                        opacity: goal.bgColor === clrs.blue ? 0.9 : 0.8
                                    }}
                                >
                                    <IntlMessage id={goal.bodyKey}/>
                                </MyText>
                            </Flex>
                        ))}
                    </Flex>
                </Flex>
            </Flex>
        </Flex>

    );
};

export default ProjectGoals; 